// 🏗️ FSD Features Layer - PricingPage Component
// FSD 아키텍처를 따라 리팩토링된 PricingPage 컴포넌트
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 4rem;\n  padding: 0 1rem;\n\n  @media (min-width: 768px) {\n    margin-top: 5rem;\n    padding: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  font-size: 2rem;\n  font-weight: 800;\n  color: var(--theme-text);\n  margin-bottom: 0.75rem;\n  text-align: center;\n\n  @media (min-width: 768px) {\n    font-size: 2.4rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  color: var(--theme-text-secondary);\n  max-width: 640px;\n  text-align: center;\n  line-height: 1.7;\n  margin-bottom: 2.5rem;\n  font-size: 0.95rem;\n\n  @media (min-width: 768px) {\n    font-size: 1.05rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1.5rem;\n  width: 100%;\n  max-width: 1100px;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  background: rgba(255, 255, 255, 0.88);\n  border-radius: 18px;\n  padding: 1.5rem;\n  border: 1px solid rgba(148, 163, 184, 0.25);\n  box-shadow: 0 24px 45px -32px rgba(15, 23, 42, 0.35);\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n  backdrop-filter: blur(6px);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n\n  &:hover {\n    transform: translateY(-6px);\n    box-shadow: 0 32px 60px -30px rgba(37, 99, 235, 0.35);\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 14px;\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.15) 0%, rgba(147, 51, 234, 0.12) 100%);\n  color: var(--theme-primary);\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--theme-text);\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  margin: 0;\n  color: var(--theme-text-secondary);\n  font-size: 0.92rem;\n  line-height: 1.6;\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  margin-top: 5rem;\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  max-width: 760px;\n  padding: 2.5rem 2.75rem;\n  border-radius: 22px;\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.18) 0%, rgba(14, 116, 144, 0.22) 100%);\n  border: 1px solid rgba(59, 130, 246, 0.25);\n  box-shadow: 0 30px 60px -35px rgba(14, 116, 144, 0.55);\n  text-align: center;\n  color: var(--theme-text);\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 54px;\n  height: 54px;\n  border-radius: 16px;\n  margin: 0 auto;\n  background: rgba(255, 255, 255, 0.75);\n  color: var(--theme-primary);\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  align-items: center;\n\n  a {\n    width: fit-content;\n  }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  max-width: 1100px;\n  display: grid;\n  gap: 1.25rem;\n  margin-bottom: 2rem;\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: 140px;\n  border-radius: 24px;\n  background: linear-gradient(\n    135deg,\n    rgba(148, 163, 184, 0.25) 0%,\n    rgba(226, 232, 240, 0.55) 50%,\n    rgba(148, 163, 184, 0.25) 100%\n  );\n  background-size: 200% 200%;\n  animation: shimmer 1.8s ease-in-out infinite;\n\n  @keyframes shimmer {\n    0% {\n      background-position: 0% 50%;\n    }\n    50% {\n      background-position: 100% 50%;\n    }\n    100% {\n      background-position: 0% 50%;\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  height: 240px;\n  border-radius: 18px;\n  background: rgba(226, 232, 240, 0.45);\n  position: relative;\n  overflow: hidden;\n\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(\n      120deg,\n      transparent 0%,\n      rgba(255, 255, 255, 0.45) 50%,\n      transparent 100%\n    );\n    transform: translateX(-100%);\n    animation: shimmer-slide 1.6s infinite;\n  }\n\n  @keyframes shimmer-slide {\n    0% {\n      transform: translateX(-100%);\n    }\n    50% {\n      transform: translateX(100%);\n    }\n    100% {\n      transform: translateX(100%);\n    }\n  }\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  max-width: 520px;\n  margin: 3rem auto 0;\n  padding: 2.25rem;\n  border-radius: 20px;\n  text-align: center;\n  background: rgba(255, 255, 255, 0.88);\n  border: 1px solid rgba(148, 163, 184, 0.25);\n  box-shadow: 0 22px 45px -30px rgba(15, 23, 42, 0.4);\n\n  h4 {\n    margin: 0 0 0.75rem;\n    font-size: 1.2rem;\n    font-weight: 700;\n    color: var(--theme-text);\n  }\n\n  p {\n    margin: 0;\n    font-size: 0.95rem;\n    color: var(--theme-text-secondary);\n    line-height: 1.6;\n  }\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  align-items: baseline;\n  gap: 0.35rem;\n  margin-bottom: 0.75rem;\n\n  .amount {\n    font-size: 2.7rem;\n    font-weight: 800;\n    letter-spacing: -0.02em;\n    background: linear-gradient(135deg, #1f2937 0%, #4b5563 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n  }\n\n  .suffix {\n    font-size: 0.95rem;\n    color: var(--theme-text-secondary);\n    font-weight: 600;\n  }\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  color: var(--theme-text-secondary);\n  font-size: 0.95rem;\n  margin-bottom: 1.5rem;\n  min-height: 2.4rem;\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.3rem 0.9rem;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  background: rgba(59, 130, 246, 0.12);\n  color: var(--theme-primary);\n\n  &.current {\n    background: rgba(16, 185, 129, 0.15);\n    color: var(--theme-success);\n  }\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-top: auto;\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  margin-top: 1.25rem;\n  font-size: 0.82rem;\n  color: var(--theme-text-secondary);\n  text-align: center;\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router';
import * as m from '@paraglide/messages';
import { Button } from '@edusense/shared-ui-kit';
import { PageContainer, Header, Logo, Title, Subtitle, PlanGrid, PlanCard } from '@edusense/shared-pricing-styles';
import { usePricingLogic } from '../hooks/usePricingLogic';
import { Sparkles, Users2, ShieldCheck, LifeBuoy, CheckCircle2 } from 'lucide-react';
var splitPlanPrice = function(price) {
    if (!price) {
        return {
            amount: '-',
            suffix: ''
        };
    }
    var match = price.match(/^([^/]+)(?:\/(.+))?$/);
    if (!match) {
        return {
            amount: price,
            suffix: ''
        };
    }
    var _match = _sliced_to_array(match, 3), amount = _match[1], suffix = _match[2];
    return {
        amount: amount.trim(),
        suffix: suffix ? "/".concat(suffix.trim()) : ''
    };
};
var Section = styled.section(_templateObject());
var SectionTitle = styled.h2(_templateObject1());
var SectionDescription = styled.p(_templateObject2());
var HighlightGrid = styled.div(_templateObject3());
var HighlightCard = styled.div(_templateObject4());
var HighlightIcon = styled.span(_templateObject5());
var HighlightTitle = styled.h3(_templateObject6());
var HighlightDescription = styled.p(_templateObject7());
var SupportSection = styled(Section)(_templateObject8());
var SupportCard = styled.div(_templateObject9());
var SupportIcon = styled.div(_templateObject10());
var SupportActions = styled.div(_templateObject11());
var HeroSkeleton = styled.div(_templateObject12());
var SkeletonBlock = styled.div(_templateObject13());
var SkeletonCard = styled.div(_templateObject14());
var EmptyState = styled.div(_templateObject15());
var PlanPriceWrap = styled.div(_templateObject16());
var PlanDescription = styled.p(_templateObject17());
var PlanBadgeRow = styled.div(_templateObject18());
var StatusBadge = styled.span(_templateObject19());
var PlanActions = styled.div(_templateObject20());
var PlanFooter = styled.div(_templateObject21());
/**
 * Map numeric plan IDs to semantic names for test IDs
 */ var getPlanTestId = function(planId) {
    var mapping = {
        '1': 'free',
        '2': 'basic',
        '3': 'pro',
        '4': 'business',
        'free': 'free',
        'basic': 'basic',
        'pro': 'pro',
        'business': 'business',
        'enterprise': 'enterprise',
        // Fallback plan IDs
        'beginner': 'basic',
        'advanced': 'pro'
    };
    return mapping[planId] || planId;
};
/**
 * PricingPage 컴포넌트 - FSD Features Layer
 * 비즈니스 로직은 usePricingLogic 훅에서 관리
 * UI는 shared/pricing-styles의 styled-components 사용
 */ export var PricingPage = function() {
    var navigate = useNavigate();
    var theme = useTheme();
    // 모든 비즈니스 로직을 usePricingLogic 훅에서 가져옴
    var _usePricingLogic = usePricingLogic(), availablePlans = _usePricingLogic.availablePlans, plansLoading = _usePricingLogic.plansLoading, plansError = _usePricingLogic.plansError, currentSubscription = _usePricingLogic.currentSubscription, subscriptionLoading = _usePricingLogic.subscriptionLoading, loadingPlanId = _usePricingLogic.loadingPlanId, handlePlanSelect = _usePricingLogic.handlePlanSelect, isAuthenticated = _usePricingLogic.isAuthenticated, user = _usePricingLogic.user;
    var hasPlans = availablePlans.length > 0;
    var isInitialLoading = plansLoading && !hasPlans;
    var hasError = !plansLoading && plansError !== null;
    /**
   * 로고 클릭 핸들러
   */ var handleLogoClick = function() {
        navigate('/');
    };
    /**
   * 개별 플랜 카드 렌더링
   */ var renderPlanCard = function(plan) {
        var isCurrentPlan = (currentSubscription === null || currentSubscription === void 0 ? void 0 : currentSubscription.planId) === plan.id;
        var isLoading = loadingPlanId === plan.id;
        var isRecommended = plan.recommended;
        var testId = getPlanTestId(plan.id); // Semantic test ID
        var isFree = testId === 'free';
        var isBusiness = testId === 'business' || testId === 'enterprise';
        // 플랜 카드 클래스 결정
        var cardClassName = '';
        if (isRecommended) cardClassName += ' recommended';
        if (isFree) cardClassName += ' free';
        if (isBusiness) cardClassName += ' business';
        var buttonVariant = isCurrentPlan ? 'default' : isRecommended ? 'secondary' : 'primary';
        var _splitPlanPrice = splitPlanPrice(plan.price), amount = _splitPlanPrice.amount, suffix = _splitPlanPrice.suffix;
        var footerMessage = isBusiness ? m.pricing_commonFeatures_realTimeCollaboration() : m.pricing_commonFeatures_multiLanguageSupport();
        var _plan_buttonText;
        return /*#__PURE__*/ React.createElement(PlanCard, {
            key: plan.id,
            theme: theme,
            className: cardClassName.trim(),
            "data-testid": "pricing-plan-".concat(testId, "-card")
        }, /*#__PURE__*/ React.createElement(PlanBadgeRow, null, isCurrentPlan && (currentSubscription === null || currentSubscription === void 0 ? void 0 : currentSubscription.status) === 'ACTIVE' && /*#__PURE__*/ React.createElement(StatusBadge, {
            className: "current"
        }, /*#__PURE__*/ React.createElement(CheckCircle2, {
            size: 14
        }), m.pricing_buttons_currentPlan())), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("h2", null, plan.name), /*#__PURE__*/ React.createElement(PlanPriceWrap, {
            "data-testid": "pricing-plan-".concat(testId, "-price")
        }, /*#__PURE__*/ React.createElement("span", {
            className: "amount"
        }, amount), suffix && /*#__PURE__*/ React.createElement("span", {
            className: "suffix"
        }, suffix)), /*#__PURE__*/ React.createElement(PlanDescription, null, plan.description || m.pricing_commonFeatures_cloudIde()), /*#__PURE__*/ React.createElement("ul", null, plan.features.map(function(feature, index) {
            return /*#__PURE__*/ React.createElement("li", {
                key: index
            }, feature);
        }))), /*#__PURE__*/ React.createElement(PlanActions, null, /*#__PURE__*/ React.createElement(Button, {
            "data-testid": "pricing-plan-".concat(testId, "-button"),
            onClick: function() {
                return handlePlanSelect(plan);
            },
            variant: buttonVariant,
            fullWidth: true,
            size: "lg",
            isLoading: isLoading,
            disabled: isCurrentPlan && (currentSubscription === null || currentSubscription === void 0 ? void 0 : currentSubscription.status) === 'ACTIVE'
        }, isCurrentPlan && (currentSubscription === null || currentSubscription === void 0 ? void 0 : currentSubscription.status) === 'ACTIVE' ? m.pricing_buttons_currentPlan() : (_plan_buttonText = plan.buttonText) !== null && _plan_buttonText !== void 0 ? _plan_buttonText : m.pricing_buttons_selectPlan()), /*#__PURE__*/ React.createElement(PlanFooter, null, footerMessage)));
    };
    return /*#__PURE__*/ React.createElement(PageContainer, {
        theme: theme
    }, /*#__PURE__*/ React.createElement(Header, {
        theme: theme
    }, /*#__PURE__*/ React.createElement(Logo, {
        onClick: handleLogoClick
    }, m.pricing_branding_logo()), /*#__PURE__*/ React.createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: '1rem'
        }
    }, isAuthenticated && user ? /*#__PURE__*/ React.createElement("span", {
        style: {
            fontSize: '0.9rem',
            color: 'var(--theme-text-secondary)'
        }
    }, m.pricing_header_greeting({
        name: user.name || user.email || ''
    })) : /*#__PURE__*/ React.createElement(Button, {
        onClick: function() {
            return navigate('/login');
        },
        variant: "outline",
        size: "sm"
    }, m.pricing_buttons_login()))), /*#__PURE__*/ React.createElement(Title, {
        theme: theme
    }, m.pricing_header_title()), /*#__PURE__*/ React.createElement(Subtitle, {
        theme: theme
    }, m.pricing_header_subtitle()), isInitialLoading && /*#__PURE__*/ React.createElement(HeroSkeleton, null, /*#__PURE__*/ React.createElement(SkeletonBlock, null), /*#__PURE__*/ React.createElement(SkeletonBlock, {
        style: {
            height: '100px'
        }
    })), currentSubscription && !subscriptionLoading && /*#__PURE__*/ React.createElement("div", {
        style: {
            padding: '1rem 2rem',
            backgroundColor: 'var(--theme-success-bg, #f0fdf4)',
            borderRadius: '8px',
            marginBottom: '2rem',
            border: '1px solid var(--theme-success, #10b981)',
            textAlign: 'center'
        }
    }, /*#__PURE__*/ React.createElement("p", {
        style: {
            margin: 0,
            color: 'var(--theme-success, #10b981)',
            fontWeight: '600'
        }
    }, m.pricing_subscription_current({
        planName: currentSubscription.planName,
        status: currentSubscription.status
    }))), /*#__PURE__*/ React.createElement(PlanGrid, null, isInitialLoading ? Array.from({
        length: 4
    }).map(function(_, index) {
        return /*#__PURE__*/ React.createElement(SkeletonCard, {
            key: index
        });
    }) : hasError ? /*#__PURE__*/ React.createElement(EmptyState, {
        style: {
            backgroundColor: 'rgba(254, 226, 226, 0.88)',
            borderColor: 'rgba(239, 68, 68, 0.5)'
        }
    }, /*#__PURE__*/ React.createElement("h4", {
        style: {
            color: 'var(--theme-error, #dc2626)'
        }
    }, "플랜 정보를 불러올 수 없습니다"), /*#__PURE__*/ React.createElement("p", {
        style: {
            color: 'var(--theme-text)'
        }
    }, plansError), /*#__PURE__*/ React.createElement(Button, {
        onClick: function() {
            return window.location.reload();
        },
        variant: "primary",
        style: {
            marginTop: '1rem'
        }
    }, "페이지 새로고침")) : hasPlans ? availablePlans.map(renderPlanCard) : /*#__PURE__*/ React.createElement(EmptyState, null, /*#__PURE__*/ React.createElement("h4", null, m.pricing_header_title()), /*#__PURE__*/ React.createElement("p", null, m.pricing_header_subtitle()))), !isInitialLoading && !hasError && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Section, null, /*#__PURE__*/ React.createElement(SectionTitle, null, m.pricing_commonFeatures_title()), /*#__PURE__*/ React.createElement(SectionDescription, null, m.pricing_header_subtitle()), /*#__PURE__*/ React.createElement(HighlightGrid, null, [
        {
            icon: Sparkles,
            title: m.pricing_commonFeatures_cloudIde(),
            description: m.pricing_commonFeatures_pluginEcosystem()
        },
        {
            icon: Users2,
            title: m.pricing_commonFeatures_realTimeCollaboration(),
            description: m.pricing_commonFeatures_multiLanguageSupport()
        },
        {
            icon: ShieldCheck,
            title: m.pricing_commonFeatures_versionControl(),
            description: m.pricing_commonFeatures_autoBackup()
        }
    ].map(function(param) {
        var Icon = param.icon, title = param.title, description = param.description;
        return /*#__PURE__*/ React.createElement(HighlightCard, {
            key: title
        }, /*#__PURE__*/ React.createElement(HighlightIcon, null, /*#__PURE__*/ React.createElement(Icon, {
            size: 22,
            strokeWidth: 1.6
        })), /*#__PURE__*/ React.createElement(HighlightTitle, null, title), /*#__PURE__*/ React.createElement(HighlightDescription, null, description));
    }))), /*#__PURE__*/ React.createElement(SupportSection, null, /*#__PURE__*/ React.createElement(SupportCard, null, /*#__PURE__*/ React.createElement(SupportIcon, null, /*#__PURE__*/ React.createElement(LifeBuoy, {
        size: 26,
        strokeWidth: 1.8
    })), /*#__PURE__*/ React.createElement(SectionTitle, null, m.support_title()), /*#__PURE__*/ React.createElement(SectionDescription, null, m.support_message()), /*#__PURE__*/ React.createElement(SupportActions, null, /*#__PURE__*/ React.createElement("a", {
        href: "mailto:support@ugot.uk",
        rel: "noreferrer"
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "primary",
        size: "sm"
    }, m.support_title())), /*#__PURE__*/ React.createElement("span", {
        style: {
            fontSize: '0.85rem',
            color: 'var(--theme-text-secondary)',
            textAlign: 'center'
        }
    }, m.pricing_commonFeatures_realTimeCollaboration()))))));
};
